<template>
    <section>
        <div class="row align-items-start">
            <img src="/static/images/page/about/banner.jpg" class="img-fluid w-100" />
        </div>
        <div class="row">
            <div class="col-12 wrapper">
                <h1 class="text-uppercase text-center text-danger my-5 font-weight-bold">
                    Tentang BTA Group
                </h1>
                <div class="row mb-4">
                    <div class="col-lg-6">
                        <div class="row portrait">
                            
                            <div class="col">
                                <img src="/static/images/page/about/portrait-2.png" class="img-fluid w-100 rounded mb-4 " />
                                <h3 class="text-center">
                                    dr. Hasahatan Manullang, MsHA
                                </h3>
                                <p class="text-muted text-center font-weight-bold">Direktur Utama</p>
                            </div>
                            <div class="col">
                                <img src="/static/images/page/about/portrait-3.png" class="img-fluid w-100 rounded mb-4 " />
                                <h3 class="text-center">
                                    Drs. H. Dadang Ridwan
                                </h3>
                                <p class="text-muted text-center font-weight-bold">Direktur Operasional</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 px-4">
                        <h2 class="text-danger text-uppercase font-weight-bold mb-4">
                            Visi
                        </h2>
                        <h2 class="font-weight-bold mb-4">
                            &ldquo;Menjadi Bimbingan Belajar Pilihan Utama Keluarga Indonesia&rdquo;
                        </h2>
                        <h2 class="text-uppercase text-danger font-weight-bold mb-4">
                            Misi
                        </h2>
                        <h3 class="mb-4">
                            1. Fokus memberikan pelayanan pendidikan bermutu dan sesuai 
                            dengan kurikulum dan kebutuhan siswa sehingga berprestasi di sekolah, 
                            diterima disekolah unggulan dan diterima di Perguruan Tinggi Negeri (PTN) Favorit
                        </h3>
                        <h3 class="mb-4">
                            2. Mengembangkan dan menerapkan Sistem Manajemen yang unggul demi 
                            terciptanya kualitas pelayanan pendidikan terbaik.
                        </h3>
                        <h3 class="mb-4">
                            3. Fokus mengembangkan inovasi dan metode pembelajaran yang inovatif dan kretif sehingga
                            tercipta proses belajar mengajar yang berkualitas
                        </h3>
                        <h3 class="mb-4">
                            4. Menerapkan proses pembelajaran yang mandiri, jujur dan bertanggung jawab
                        </h3>
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col-12">
                        <h2 class="text-danger font-weight-bold mb-4">
                            Sejarah BTA Group
                        </h2>
                        <div class="row">
                            <div class="col-lg-6">
                                <p>
                                    Pada era tahun 70-an sampai dengan awal 80-an, SMA 8 belum menjadi tujuan favorit bagi lulusan SMP
                                    yang hendak melanjutkan pendidikan ke tingkat SMA, mengingat saat itu belum banyak alumni SMA 8 yang diterima 
                                    di Perguruan Tinggi Negeri (PTN). Melihat kenyataan tersebut pada awal tahun 80-an beberapa alumni SMA 8 yang telah lulus dan diterima 
                                    di Universitas Indonesia berinisiatif untuk memberikan bimbingan khusus bagi siswa kelas XII SMA 8 
                                    dalam mempersiapkan diri menghadapi Ujian Masuk Perguruan Tinggi Negeri.
                                </p>
                                <hr class="my-4" />
                                <h3 class="font-weight-bold mb-4">
                                    &ldquo;Kini BTA terus berkembang dan menjadi badan usaha dibawah BTA Group yang menaungi beberapa cabang utama&rdquo;
                                </h3>
                                <hr class="my-4" />
                                <p>
                                    Kegiatan tersebut yang kemudian dikenal nama Bimbingan Tes Alumni SMA 8 / BTA 8 didirikan oleh beberapa alumni SMA 8 diantaranya adalah :
                                </p>
                                <ol>
                                    <li>Ahmad Rivay (Alm), Fisika UI ‘77</li>
                                    <li>Sonny Soekarsono (Alm.), Matematika UI’78</li>
                                    <li>Adrizal, Biologi UI ‘78</li>
                                    <li>Budhi Soesilo, Pendidikan Dokter UI ‘79</li>
                                    <li>Sugihardjo, Teknik Sipil UI ’80</li>
                                    <li>Hasahatan Manullang, Pendidikan Dokter UI ‘81</li>
                                </ol>
                                <p>
                                    Sejak saat itu berkat bimbingan dari para alumni SMA 8 di BTA dan guru-guru di sekolah semakin banyak alumni SMA 8 yang diterima di 
                                    Perguruan Tinggi Negeri Favorit dan perlahan tapi pasti semakin mengangkat pamor SMA 8 Jakarta menjadi sekolah unggulan tingkat nasional.
                                </p>
                                <p>
                                    Pada awal tahun ’90-an BTA terus berkembang pesat dan semakin banyak sekolah unggulan lainnya seperti 
                                    SMA 1, SMA 3, SMA 6, 28, SMA 68, SMA 61, SMA 81, SMA 71, SMA 13, SMA 12, SMA 78, dan SMA 70, SMA 85, SMA 6, SMA 82 
                                    yang meminta bantuan agar kegiatan BTA juga diselenggarakan di sekolah tersebut.
                                </p>
                                <p>
                                    Kini BTA terus berkembang dan menjadi badan usaha dibawah BTA Group yang menaungi beberapa cabang utama seperti 
                                    BTA 8 Soepomo, BTA 45, BTA 8 SMP, BTA 8 DuTA, BTA 8 Fatmawati, dan BTA 8 Depok dan mitra BTA yang tersebar 
                                    di wilayah Jakarta dan beberapa kota di luar Jakarta.
                                </p>
                            </div>
                            <div class="col-lg-6">
                                <img src="/static/images/page/about/FOTOBTA.jpeg" class="img-fluid w-100 mb-5" />
                                <img src="/static/images/page/about/BTA09069resize.jpg" class="img-fluid w-100 mb-5" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" id="excellence">
                        <h2 class="text-danger text-uppercase font-weight-bold text-center mb-4">
                            Keunggulan BTA Group
                        </h2>
                        <div class="row">
                            <div class="col-lg-4 col-md-6 text-center p-5">
                                <img src="/static/images/graduate.svg" class="img-fluid w-100 mb-4" style="height: 140px; margin-top: -40px;" />
                                <h3 class="font-weight-bold text-uppercase">Pengajar Unggul</h3>
                                <p>
                                    Mayoritas pengajar BTA adalah alumni UI, ITB, dan PTN ternama lainnya. 
                                    Rata-rata usia pengajar 25 tahun, memberikan atmosfer belajar yang berbeda, 
                                    gaya penyampaian materi yang jenaka menjadikan proses belajar mengajar atraktif, 
                                    serius dan menyenangkan.
                                </p>
                            </div>
                            <div class="col-lg-4 col-md-6 text-center p-5">
                                <img src="/static/images/bookmark.svg" class="img-fluid w-100 mb-4" />
                                <h3 class="font-weight-bold text-uppercase">Kumpulan Soal Unggul</h3>
                                <p>
                                    Materi belajar disusun sedemikian rupa sesuai dengan kebutuhan siswa, 
                                    tentunya dengan dukungan bank data soal yang lengkap dan bervariasi. 
                                    Selain itu modul dibuat dengan menggunakan kualitas kertas, layout, desain fisik yang berkualitas.
                                </p>
                            </div>
                            <div class="col-lg-4 col-md-6 text-center p-5">
                                <img src="/static/images/idea.svg" class="img-fluid w-100 mb-4" />
                                <h3 class="font-weight-bold text-uppercase">Metode Belajar Unggul</h3>
                                <p>
                                    Kegiatan belajar di BTA selama tujuh, hari seminggu non-stop yang dibagi kedalam beberapa pola belajar. 
                                    Evaluasi kelas setiap semester, diatur sesuai dengan hasil tryout yang diraih, 
                                    sehingga siswa termotivasi untuk selalu maksimal mengerjakan tryout.
                                </p>
                            </div>
                            <div class="col-lg-4 col-md-6 text-center p-5">
                                <img src="/static/images/task.svg" class="img-fluid w-100 mb-4" />
                                <h3 class="font-weight-bold text-uppercase">Tryout Unggul</h3>
                                <p>
                                    Untuk siswa kelas XII, BTA memberikan pelayanan tryout rutin dengan kualitas soal yang 
                                    disesuaikan dengan ujian yang sebenarnya. BTA Menggunakan Sistem tryout online yang dirancang seperti ujian aslinya.
                                </p>
                            </div>
                            <div class="col-lg-4 col-md-6 text-center p-5">
                                <img src="/static/images/portofolio.svg" class="img-fluid w-100 mb-4" />
                                <h3 class="font-weight-bold text-uppercase">Tes Bakat dan Minat</h3>
                                <p>
                                    Mengetahui minat dan bakat siswa memang tidak mudah, karena itu BTA berkerja sama dengan 
                                    Fakultas Psikologi UI mengadakan Tes Minat Bakat untuk memberikan masukan bagi siswa yang 
                                    mengalami kesulitan menentukan program studi di Universitas.
                                </p>
                            </div>
                            <div class="col-lg-4 col-md-6 text-center p-5">
                                <img src="/static/images/conference.svg" class="img-fluid w-100 mb-4" />
                                <h3 class="font-weight-bold text-uppercase">Parenting & Seminar</h3>
                                <p>
                                    Seminar PTN diselenggarakan setiap tahun sebagai wadah bertemunya orang tua siswa dengan pengurus BTA. 
                                    Pada acara ini orang tua siswa akan mendapatkan hasil laporan tryout dan pengarahan perkembangan penerimaaan mahasiswa terbaru.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "StaticAbout",
        mounted() {
            document.title = 'About Us - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    .wrapper { padding: 0 3rem; }
    .wrapper .portrait img { height: auto; }
    hr { padding-top: 1px; border-top: 2px solid #d31027; }
    #excellence img { height: 100px; }
    .fit-cover { object-fit: cover; }
</style>



// WEBPACK FOOTER //
// src/components/static/About.vue